import type { CalendarDate } from '@harvestiq/zod';
import { zCalendarDate } from '@harvestiq/zod';
import type { Dayjs } from './dayjs';
import { nowCdtDayjs } from './dayjs';

export const currentYear = new Date().getFullYear();

export const dateToCalendarDate = (date: Date): CalendarDate => {
  if (!date) {
    throw new Error('date is required');
  }

  if (typeof date === 'string') {
    return calendarDate(date as string);
  }
  return zCalendarDate().parse(date.toISOString().slice(0, 10));
};

export const dayjsToCalendarDate = (date: Dayjs): CalendarDate => {
  return zCalendarDate().parse(date.format('YYYY-MM-DD'));
};

export const calendarDate = (dateString: string): CalendarDate => {
  if (!dateString) {
    throw new Error('date is required');
  }
  if (dateString.trim().length < 10) {
    throw new Error(
      `date must be in the format YYYY-MM-DD and the value: ${dateString} is invalid`
    );
  }
  return zCalendarDate().parse(dateString.slice(0, 10));
};

export const todayCalendarDate = (): CalendarDate => {
  return dayjsToCalendarDate(nowCdtDayjs());
};

export const sevenDaysBeforeTodayCalendarDate = (): CalendarDate => {
  return dayjsToCalendarDate(nowCdtDayjs().subtract(7, 'day'));
};
